import React from 'react'
import ModalBox from '../../components/modal/ModalBox'
import useButtonLoader from '../../hooks/UseButtonLoader'
import { toastMessage } from '../../utils/toastMessage'
import { changeBannerStatus } from '../../services/bannerManagement'

const BannerStatus = ({ show, close, setListing, status, id }) => {
  // handle all hooks
  const [buttonref, buttonLoader] = useButtonLoader('Yes')

  // handle all function

  //--------------change-status-category------------------------
  const changeStatus = async () => {
    try {
      buttonLoader(true)
      let sendData = { status: !status, bannerId: id }
      const { data } = await changeBannerStatus(sendData)
      if (data.code === 200) {
        setListing((prevListing) => {
          return prevListing.map((category) => {
            if (category._id === id) {
              return { ...category, status: !status }
            }
            return category
          })
        })
        toastMessage(data.message, 'success', 'categoryStatus')
        close()
      } else {
        toastMessage(data.message, 'error', 'categoryStatus')
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      buttonLoader(false)
    }
  }
  return (
    <ModalBox
      status={show}
      onClose={close}
      title="Change Banner Status"
      description="Do you want to change the status of this banner?"
      action={changeStatus}
      ref={buttonref}
    />
  )
}

export default BannerStatus
